import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { environment } from 'environments/environment';

declare const paypal

@Component({
  selector: 'paypal-modal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss'],
  encapsulation: ViewEncapsulation.None
})



export class PaypalComponent implements OnInit, OnChanges {

  @Input() visible: boolean = false;
  @Output() isVisible: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() successTx: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() amountSelected: number;
  @Input() purchaseContext: any;
  @ViewChild('paypal', { static: true }) paypalElement: ElementRef //html ement Paypal Smart button


  Paypal
  //product:any
  //payeeEmail: string
  //paidFor: boolean
  paypalConfig: any

  constructor(private toastService: ToastService) {
    this.Paypal = paypal
  }
  ngOnInit() {

  }

  ngOnChanges() {
    /*this.product = {
    price: '10',
    description: 'Check Amount'
    }// this property can be make dynamically from your web api
    this.payeeEmail = 'umberto@kryptomon.co'
    this.paidFor = false; //Payment Successful Message handling
  */
    var post

    if (this.purchaseContext) {
      if (this.purchaseContext.reason == "sale") {
        post = {
          email: this.purchaseContext.userEmail,
          walletId: this.purchaseContext.walletId,
          indexSale: this.purchaseContext.indexSale,
          qty: 1,
          reason: this.purchaseContext.reason,
          signature: 'abcdef',
          contractAddress: this.purchaseContext.contractAddress,
          itemId: "skip"
        }
      } else {
        post = {
          email: this.purchaseContext.userEmail,
          walletId: this.purchaseContext.walletId,
          itemId: this.purchaseContext.itemId,
          qty: this.purchaseContext.qty,
          reason: this.purchaseContext.reason,
          signature: 'abcdef'
        }
      }
    }

    this.paypalConfig = {//Configuration for paypal Smart Button
      style: {
        color: 'black',
        shape: "pill",
        layout: "vertical"
      },
      createOrder: async () => {
        try {
          const response = await fetch(environment.apiBaseUrlV22 + "paypal/order", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            // use the "body" param to optionally pass additional order information
            // like product ids and quantities
            body: JSON.stringify(post),
          });

          const orderData = await response.json();
          console.log(orderData)
          if (orderData.id) {
            return orderData.id;
          } else {
            const errorDetail = orderData?.details?.[0];
            const errorMessage = errorDetail
              ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
              : JSON.stringify(orderData);

            throw new Error(errorMessage);
          }
        } catch (error) {
          console.error(error);
          this.toastService.genericError(`Could not initiate PayPal Checkout...<br><br>${error}`);
        }
      },
      onApprove: async (data, actions) => {
        try {
          console.log(data)
          const response = await fetch(environment.apiBaseUrlV22 + `paypal/order/${data.orderID}/complete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const orderData = await response.json();
          // Three cases to handle:
          //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
          //   (2) Other non-recoverable errors -> Show a failure message
          //   (3) Successful transaction -> Show confirmation or thank you message

          const errorDetail = orderData?.details?.[0];

          if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
            // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
            return actions.restart();
          } else if (errorDetail) {
            // (2) Other non-recoverable errors -> Show a failure message
            throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
            this.toastService.genericError(
              `Transaction ${errorDetail.description} (${orderData.debug_id})<br><br>See console for all available details`,
            );
          } else if (!orderData.purchase_units) {
            throw new Error(JSON.stringify(orderData));
            this.toastService.genericError(
              `Transaction ${JSON.stringify(orderData)}<br><br>See console for all available details`,
            );
          } else {
            // (3) Successful transaction -> Show confirmation or thank you message
            // Or go to another URL:  actions.redirect('thank_you.html');
            const transaction =
              orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
              orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
            /*this.toastService.add({
              severity: 'success',
              summary: 'shared.success',
              detail: 'toastMessage.purchasedItem',
            });*/
            this.visible = false;
            this.isVisible.emit(this.visible)
            this.successTx.emit(true)
            console.log(
              "Capture result",
              orderData,
              JSON.stringify(orderData, null, 2),
            );
          }
        } catch (error) {
          console.error(error);
          this.toastService.genericError(
            `Sorry, your transaction could not be processed...<br><br>${error}`,
          );
        }
      },
      onError: err => {
        console.log(err)
      }
    }
    paypal.Buttons(this.paypalConfig).render(this.paypalElement.nativeElement)
  }

  onHide() {
    this.isVisible.emit(this.visible)
  }
}
